import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

headerStyles.cancelButton = {
    variant: "secondary",
};
headerStyles.buttonSet = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 4, 3, 3],
};
headerStyles.titleWrapper = {
    width: [10, 10, 8, 9, 9],
};
headerStyles.title = {
    variant: "h2",
    color: "primary",
};
